
import {
  defineComponent,
  getCurrentInstance,
  onMounted,
  reactive,
  ref,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "LoginView",
  setup() {
    const store = useStore();
    const { proxy } = getCurrentInstance() as any;
    const route = useRouter();
    const imgUrl = ref();
    const params = reactive({
      no: "",
      pwd: "",
      code: "",
      uuid: "",
    });
    // 获取uuid
    function uid() {
      const s = [];
      const hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((19 & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      const uuid = s.join("");
      return uuid;
    }
    uid();
    function imageClick() {
      params.uuid = uid();
      imgUrl.value = `${proxy.$serverUrl}/imgcode/getcode.do?uuid=${params.uuid}`;
    }
    imageClick();
    function goHome() {
      if (params.no && params.pwd && params.code) {
        proxy
          .$post(`${proxy.$serverUrl}/staff/login.json`, params)
          .then((res: any) => {
            // console.log(res);
            if (res.data.success) {
              sessionStorage.setItem("token", res.data.data.token);
              store.commit("updataToken", res.data.data.token);
              // console.log(store.state.token);

              sessionStorage.setItem("no", res.data.data.staff.no);
              sessionStorage.setItem("name", res.data.data.staff.name);
              sessionStorage.setItem(
                "companyNo",
                res.data.data.staff.companyNo
              );
              sessionStorage.setItem(
                "companyName",
                res.data.data.staff.companyName
              );
              sessionStorage.setItem(
                "departmentNo",
                res.data.data.staff.departmentNo
              );
              sessionStorage.setItem(
                "departmentName",
                res.data.data.staff.departmentName
              );
              route.push("/home");
            } else {
              imageClick();
              params.code = "";
              alert(res.data.message);
            }
          })
          .catch(function (error: any) {
            alert(error);
            console.log(error);
          });
      } else {
        alert("请将用户名、密码、验证码正确填写后再登录");
      }
    }
    return {
      goHome,
      imageClick,
      params,
      imgUrl,
      store,
    };
  },
});
